import type { UserRole } from '@/types/domain'
import { api } from '@/api/client'

export type AnnouncementStatus = 'draft' | 'published' | 'withdrawn'

export type PendingAnnouncement = {
  id: string
  title: string
  body: string
  visible_from: string | null
  published_at: string | null
}

export type AdminAnnouncement = {
  id: string
  title: string
  body: string
  target_roles: UserRole[]
  status: AnnouncementStatus
  visible_from: string | null
  visible_until: string | null
  published_at: string | null
  withdrawn_at: string | null
  created_by: string | null
  created_at: string
  updated_at: string
  read_count: number
  target_count: number
}

export type AnnouncementReader = {
  user_id: string
  full_name: string | null
  email: string
  role: UserRole
  read_at: string
}

export type AnnouncementDraft = {
  title: string
  body: string
  target_roles: UserRole[]
  visible_from: string | null
  visible_until: string | null
}

export async function getMyPendingAnnouncements(): Promise<PendingAnnouncement[]> {
  const { data } = await api.GET('/api/v1/users/me/announcements')
  return data!
}

export async function markAnnouncementRead(id: string): Promise<void> {
  await api.POST('/api/v1/announcements/{id}/reads', { params: { path: { id } } })
}

export async function adminListAnnouncements(): Promise<AdminAnnouncement[]> {
  const { data } = await api.GET('/api/v1/announcements')
  return data! as AdminAnnouncement[]
}

export async function adminGetAnnouncementReaders(id: string): Promise<AnnouncementReader[]> {
  const { data } = await api.GET('/api/v1/announcements/{id}/readers', { params: { path: { id } } })
  return data! as AnnouncementReader[]
}

export async function createAnnouncement(draft: AnnouncementDraft): Promise<void> {
  await api.POST('/api/v1/announcements', { body: draft })
}

export async function updateAnnouncement(id: string, draft: AnnouncementDraft): Promise<void> {
  await api.PUT('/api/v1/announcements/{id}', { params: { path: { id } }, body: draft })
}

export async function deleteAnnouncement(id: string): Promise<void> {
  await api.DELETE('/api/v1/announcements/{id}', { params: { path: { id } } })
}

export async function publishAnnouncement(id: string): Promise<void> {
  await api.POST('/api/v1/announcements/{id}/publication', { params: { path: { id } } })
}

export async function withdrawAnnouncement(id: string): Promise<void> {
  await api.POST('/api/v1/announcements/{id}/withdrawal', { params: { path: { id } } })
}
